import { Component, OnInit, OnDestroy } from '@angular/core';
import { ClickService } from 'src/app/services/click.service';
import { StationService } from 'src/app/modules/station/services/station.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ErrorService } from 'src/app/core/services/error.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  dios = false;
  id: any;
  idGroup: any;
  idStation: any;
  rol: any;
  showText = false;

  constructor(
    public clickService: ClickService,
    public stationService: StationService,
    private errorService: ErrorService
  ) {
    this.rol = localStorage.getItem('rol');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
   }

  ngOnInit() {
    this.id = localStorage.getItem('id');
    this.idStation = localStorage.getItem('idStation');

    // Solo cargar perfil si no hay ID en localStorage
    // El HeaderComponent ya carga el perfil, así que normalmente no será necesario
    if (!this.id) {
      this.getProfile();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getProfile(): void {
    this.dios = this.rol === 'Dios';

    this.stationService.getProfile(this.dios, this.idGroup)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          if (data._id) {
            this.id = data._id;
            localStorage.setItem('id', data._id);
          }
        },
        error: (err) => {
          console.error('Error cargando perfil en sidebar:', err);
          // El ErrorService manejará la visualización del error
          this.errorService.handle(err);
        }
      });
  }

  openSidebar() {
    this.showText = true;
  }

  closeSidebar() {
    this.showText = false;
  }

  clickPage(page: any) {
    this.clickService.clickPage(this.id, this.idStation, page, 'GasPremia')
      .pipe()
      .subscribe(
        (data) => {
          // console.log(data);
        });
  }

}
